(function () {
    'use strict';

    angular
        .module('app.purchase')
        .factory('app.purchase.purchaseFlowService', [
            '$sessionStorage',
            '$http',
            'config',
            '$q',
            'paymentTypes',
            purchaseFlowService
        ]);

    function purchaseFlowService($sessionStorage, $http, config, $q, paymentTypes) {
        var vm = this;
        vm.userInfo = {};
        vm.userName = '';
        var cachedData = [];
        // Service API
        return {
            getPlanOptions: getPlanOptions,            
            checkStatusMessages: checkStatusMessages,
            getPlanOptionsByState: getPlanOptionsByState,
            getPurchase: getPurchase,
            getPlanStartDate: getPlanStartDate,
            setPlanSelection: setPlanSelection,
            applyPromoCode: applyPromoCode,
            updatePrimaryApplicantInfo: updatePrimaryApplicantInfo,
            updateAssociateMemberInfo: updateAssociateMemberInfo,
            completePurchase: completePurchase,
            getCreditCardType: getCreditCardType,
            getCardImgPath: getCardImgPath,
            getPlanSummary: getPlanSummary,
            updatePlanSummary: updatePlanSummary,
            addCreditCard: addCreditCard,
            addCheckingAccount: addCheckingAccount,
            determineLogo: getCardImgPath,
            determineLastDigits: determineLastDigits,
            updatePurchase: updatePurchase,
            sendInvitation: sendInvitation,
            validateEmailAddress: validateEmailAddress,
            clearPurchase: clearPurchase,
            removePaymentAccount: removePaymentAccount,
            getUser: getUser,
            generateOTP: generateOTP,
            authenticateOTP: authenticateOTP,
            signIn: signIn,
            getUserName: getUserName,
            getUserInfo: getUserInfo,
            sendPasswordResetEmail: sendPasswordResetEmail,
            sendActivationEmail: sendActivationEmail,
            getFeatureFlags: getFeatureFlags,
            getSalesTax: getSalesTax
        };

        function getFeatureFlags() {
            var deferred = $q.defer();
            var apiUrl = environment.treatmentApiUrl + 'featureFlag/1';

            if (!cachedData[1]) {
                $http.get(apiUrl)
                    .then(function (response) {
                        cachedData[1] = response.data;
                        deferred.resolve(cachedData[1]);
                    })
                    .catch(function (error) {
                        deferred.reject(error);
                    });
            } else {
                deferred.resolve(cachedData[1]);
            }

            return deferred.promise;
        }        

        function removePaymentAccount() {
            return $http.post(environment.salesApiUrl + 'purchase/portal/remove-payment-accounts');
        }

        function validateEmailAddress(emailAddress) {
            return $http.post(environment.salesApiUrl + 'services/check-uniqueness', { emailAddress: emailAddress });
        }

        function clearPurchase() {
            var response = $q.defer();
            response.resolve();
            return response.promise;
        }

        function getPurchase(complete) {
            return $http
                .get(environment.salesApiUrl + 'purchase/portal/get-purchase-summary?complete=' + (complete || 'false'))
                .then(function (data) {
                    return data.data;
                });
        }

        function addCreditCard(payment) {
            return $http
                .post(environment.salesApiUrl + 'purchase/portal/add-credit-card', payment)
                .then(function (data) {
                    return data.data;
                });
        }

        function addCheckingAccount(payment) {
            return $http
                .post(environment.salesApiUrl + 'purchase/portal/add-checking-account', payment)
                .then(function (data) {
                    return data.data;
                });
        }

        function updatePurchase(purchase) {
            var response = $q.defer();
            //$sessionStorage.purchase = purchase;
            response.resolve();
            return response.promise;
        }

        function applyPromoCode(code) {
            return $http
                .post(environment.salesApiUrl + 'purchase/portal/apply-promo-code', { code: code })
                .then(function (data) {
                    return data.data;
                });
        }

        function getPlanSummary() {
            //return $sessionStorage['planSummary'];
            return null;
        }

        function updatePlanSummary(value) {
            //$sessionStorage['planSummary'] = value;
        }

        function getPlanOptions(planeName) {
            var data = {
                PlanName: planeName || siteContent.plan
            };

            var config = {
                params: data,
                headers: { 'Accept': 'application/json' }
            };

            return $http.get(environment.salesApiUrl + 'services/get-plan-options', config).then(function (data) {
                return data.data;
            });
        }
        
        function checkStatusMessages() {
            var data = {
                Portal: environment.portalId
            };
            var config = {
                params: data,
                headers: { 'Accept': 'application/json' }
            };
            return $http
            .get(environment.treatmentApiUrl + 'authentication/system-messages', config)
            .then(function (data) {
                return data.data;
            });
        }

        function getPlanOptionsByState() {
            var data = {
                PlanNamePrefix: siteContent.planNamePrefix,
                OrganizationId: siteContent.organizationId,
                State: siteContent.currentState
            };

            var config = {
                params: data,
                headers: { 'Accept': 'application/json' }
            };
            return $http
                .get(environment.salesApiUrl + 'services/get-plan-options-by-state', config)
                .then(function (data) {
                    return data.data;
                });
        }
        
        function getPlanStartDate(plan){
            return $http
                .get(environment.salesApiUrl + 'services/get-plan-status?planName='+plan)
                .then(function (data) {
                    return data.data;
                });
        }
        function setPlanSelection(plan, planAcronym) {
            return $http
                .post(environment.salesApiUrl + 'purchase/portal/select-plan', {
                    coverageLevelId: plan,
                    source: planAcronym + 'PurchasePortal'
                })
                .then(function (data) {
                    return data.data;
                });
        }

        function updatePrimaryApplicantInfo(value, invalidEmail) {
            return $http.post(environment.salesApiUrl + 'purchase/portal/add-applicants', value).then(function (data) {
                return data.data;
            });
        }
        
        function updateAssociateMemberInfo(value) {
            //return getPurchase().then(function (purchase) {
            //    purchase.associatedApplicants = value;
            //    return updatePurchase(purchase);
            //});
        }

        function generateSessionGuid() {
            var d = new Date().getTime();
            if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
                d += performance.now(); //use high-precision timer if available
            }
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                // tslint:disable-next-line:no-bitwise
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                // tslint:disable-next-line:no-bitwise
                return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
            });
        }

        function completePurchase(cardInfo, checkInfo, accountNumber, isPlanAutoRenewal,shouldNotifyByMail, isMedicalConfirmed,captchaResponse) {            
            var endPointUrl = environment.salesApiUrl + 'purchase/portal/complete-purchase';
            return $http.post(endPointUrl, { creditCardInfo: cardInfo, CheckingAccountInfo: checkInfo, accountNumber: accountNumber, isPlanAutoRenewal: isPlanAutoRenewal, shouldNotifyByMail: shouldNotifyByMail, isMedicalConfirmed: isMedicalConfirmed, captchaToken : captchaResponse });
        }

        /**
         * Determines the credit card type from the credit card number.
         * @param {string} The credit card number
         * @returns {string} - Returns the credit card type.
         */
        function getCreditCardType(cardNumber) {
            return /^5[1-5]/.test(cardNumber)
                ? 'mastercard'
                : /^4/.test(cardNumber)
                ? 'visa'
                : /^3[47]/.test(cardNumber)
                ? 'amex'
                : /^6011|65|64[4-9]|622(1(2[6-9]|[3-9]\d)|[2-8]\d{2}|9([01]\d|2[0-5]))/.test(cardNumber)
                ? 'discover'
                : null;
        }

        //Returns the img src path for the credit card specified by cardType
        function getCardImgPath(payment) {
            var cardType = (payment.paymentType || '').toLowerCase();

            var imgPath = '/assets/images/credit-cards/';

            if (cardType === 'echeck') {
                return imgPath + 'ic-account-balance.svg';
            }
            if (cardType === 'vi') {
                return imgPath + 'visa-dark.svg';
            }
            if (cardType === 'ax') {
                return imgPath + 'american-express-dark.svg';
            }
            if (cardType === 'mc') {
                return imgPath + 'mastercard-dark.svg';
            }
            if (cardType === 'di') {
                return imgPath + 'discover-dark.svg';
            }
            if (cardType === 'hsa') {
                return imgPath + 'hsa-icon.svg';
            }
            if (cardType === 'fsa') {
                return imgPath + 'fsa-icon.svg';
            }

            //If we've made it this far, then return the Unknown card logo
            return imgPath + 'unknown-card.png';
        }

        function determineLastDigits(paymentInfo) {
            var lastDigits = '';

            if (paymentInfo.paymentType === paymentTypes.creditCard) {
                var cardNumber = paymentInfo.creditCardInfo.cardNumber;
                lastDigits = cardNumber.substring(cardNumber.length - 4, cardNumber.length);
            } else if (paymentInfo.paymentType === paymentTypes.checkingAccount) {
                var accountNumber = paymentInfo.checkingAccountInfo.accountNumber;
                lastDigits = accountNumber.substring(accountNumber.length - 4, accountNumber.length);
            } else {
                lastDigits = 'N/A';
            }

            return lastDigits;
        }

        function sendInvitation(phoneNumber, captchaResponse) {
            return $http.post(environment.salesApiUrl + 'services/send-mysmile-invite', {
                phoneNumber: phoneNumber,
                captchaResponse: captchaResponse,
                site: siteContent.theme
            });
        }

        function getUser(userName) {
            vm.userName = userName;
            return $http.post(environment.salesApiUrl + 'purchase/portal/get-user', {userName: userName}).then(function (response) {
                vm.userInfo = response.data;
                return response.data;
            });
        }

        function generateOTP(request) {
            return $http.post(environment.salesApiUrl + 'purchase/portal/generate-otp', request).then(function (response) {
                return response.data;
            });
        }

        function authenticateOTP(request) {
            vm.userName = '';
            return $http.post(environment.salesApiUrl + 'purchase/portal/authenticate-otp', request).then(function (response) {
                vm.userName = response.data.userName;
                return response.data;
            });
        }
        
        function signIn(request) {
            vm.userName = '';
            return $http.post(environment.salesApiUrl + 'purchase/portal/sign-in', request).then(function (response) {
                vm.userName = response.data.userName;
                return response.data;
            });
        }

        function getUserInfo() {
            return vm.userInfo;
        }

        function getUserName() {
            return vm.userName;
        }

        function sendPasswordResetEmail(request) {
            return $http.post(environment.salesApiUrl + 'purchase/portal/send-password-reset-email', request);
        }

        function sendActivationEmail(request) {
            return $http.post(environment.treatmentApiUrl + 'members/send-activation-email', request);
        }
        function getSalesTax(request) {
            return $http.get(environment.salesApiUrl + 'purchase/portal/get-salestax-info?zipCode=' + request);
        }
    }
})();

/**
 * Application Features
 * @see purchaseFlowService
 */
var Features = {
    /**
     * ShowMedicalAcknowledge
     */
    ShowMedicalAcknowledge: 'purchase:medi-cal-acknowledge',
    ShowAutoRenewalDisclaimer: 'purchase:auto-renewal-disclaimer'
};
